export const replaceElement = (oldNode: Node, newNode: Node) =>
  oldNode.parentNode?.replaceChild(newNode, oldNode);
